export const dropdownDefaultWidth = 400
export const defaultAllKey = '__all__'
export const defaultNoneKey = '__none__'
